import type {
  PaymentMethod,
  TopUpStatus,
} from "@polifonia/interlude/billingConstants";
import dayjs from "dayjs";
import type { TFunction } from "i18next";

export interface TopupFilters {
  dateFrom: string;
  dateTo: string;
  status: TopUpStatus | null;
}

export const getStatusLabels = (t: TFunction): Record<TopUpStatus, string> => ({
  paid: t("billing.topup.status.paid"),
  pending: t("billing.topup.status.pending"),
  processing: t("billing.topup.status.processing"),
  awaiting_payment: t("billing.topup.status.awaitingPayment"),
  failed: t("billing.topup.status.failed"),
  cancelled: t("billing.topup.status.cancelled"),
});

export const getPaymentMethodLabels = (
  t: TFunction,
): Record<PaymentMethod, string> => ({
  credit_card: t("billing.topup.paymentMethod.creditCard"),
  wire_transfer: t("billing.topup.paymentMethod.wireTransfer"),
});

export const TOPUP_TABLE_COLUMN_COUNT = 5;

const DEFAULT_DATE_RANGE_DAYS = 14;
const MAX_DATE_RANGE_DAYS = 90;
const DATE_FORMAT = "YYYY-MM-DD";

export const getDefaultDateRange = (): {
  dateFrom: string;
  dateTo: string;
} => ({
  dateFrom: dayjs()
    .subtract(DEFAULT_DATE_RANGE_DAYS, "day")
    .format(DATE_FORMAT),
  dateTo: getMaxDate(),
});

export const getMinDate = (): string =>
  dayjs().subtract(MAX_DATE_RANGE_DAYS, "day").format(DATE_FORMAT);

export const getMaxDate = (): string => dayjs().format(DATE_FORMAT);
